import React, { useState } from "react";
import "./AddWorkLocation.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import AddWorkLocationLayout from "../../layouts/Admin/AddWorkLocationLayout";

const AddWorkLocation = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <AddWorkLocationLayout />
    </>
  );
};

export default AddWorkLocation;
